import { TranslationContext } from 'contexts/translation-context';

import { useContext } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { BlueLink } from 'components/common/link';
import { PlanState } from '../reducers/plan';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.theme.colors.white};
  border: 1px solid ${props => props.theme.colors.siteCardBorder};
  border-radius: 16px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  padding: 40px 56px 48px;
  width: 100%;
  max-width: 760px;
  box-sizing: border-box;

  @media (max-width: 999px) {
    border-radius: 16px;
    margin: 0 12px;
    padding: 28px 20px;
    width: calc(100% - 24px);
  }
`;
const FirstText = styled.div`
  font-family: ${props => props.theme.fonts.FunnelDisplay};
  color: ${props => props.theme.colors.black};
  font-size: 26px;
  font-weight: 700;
  line-height: 1.2;
  text-align: center;
  margin: 0 0 20px;

  @media (max-width: 999px) {
    font-size: 24px;
  }
`;
const SecondText = styled.div`
  font-family: ${props => props.theme.fonts.interSans};
  color: ${props => props.theme.colors.siteBlack};
  font-size: 14px;
  line-height: 1.5;
  text-align: center;
  white-space: break-spaces;

  @media (max-width: 999px) {
    font-size: 13px;
  }
`;
const StyledLink = styled(BlueLink)`
  font-family: ${props => props.theme.fonts.interSansSemiBold};
  color: ${props => props.theme.colors.siteIndigo};
  font-size: 14px;

  @media (max-width: 999px) {
    font-size: 13px;
  }
`;
const StyledDiv = styled.div`
  margin-top: 28px;
  border: 1px solid ${props => props.theme.colors.siteCardBorder};
  background-color: ${props => props.theme.colors.white};
  width: 100%;
  max-width: 560px;
  border-radius: 14px;
  padding: 24px 28px;
  box-sizing: border-box;

  @media (max-width: 999px) {
    padding: 22px 18px;
  }
`;

export const SuccessPageForPriceList = () => {
  const TRANSLATION_TEXT = useContext(TranslationContext) as { [key: string]: string };
  const paymentStatus = useSelector((state: { plan: PlanState }) => state.plan?.paymentStatus);
  const isAchPaymentInVerification = paymentStatus === 'AchPaymentInVerification';

  return (
    <Container>
      {isAchPaymentInVerification ? (
        <>
          <FirstText>{TRANSLATION_TEXT.ach_payment_received_title}</FirstText>
          <SecondText>{TRANSLATION_TEXT.ach_payment_received_body}</SecondText>
          <SecondText>{TRANSLATION_TEXT.ach_payment_received_email_notice}</SecondText>
        </>
      ) : (
        <>
          <FirstText>{TRANSLATION_TEXT.thank_you_for_subscribing_price_list}</FirstText>
          <SecondText>{TRANSLATION_TEXT.you_will_receive_an_email_1}</SecondText>
          <SecondText>{TRANSLATION_TEXT.you_will_receive_an_email_2}</SecondText>
        </>
      )}
      <StyledDiv>
        <SecondText>{TRANSLATION_TEXT.calculate_diamond_prices_on_the_go}</SecondText>
        <SecondText>
          {`${TRANSLATION_TEXT.download_the_rapnet_app} `}
          <StyledLink
            external
            newTab
            to={'https://apps.apple.com/il/app/rapnet-the-diamond-market/id530519916'}
          >{`App Store`}</StyledLink>
          {` or `}
          <StyledLink
            external
            newTab
            to={'https://play.google.com/store/apps/details?id=com.rapnet'}
          >{`Google Play`}</StyledLink>
        </SecondText>
      </StyledDiv>
    </Container>
  );
};
export default SuccessPageForPriceList;
